/**
 * An analytics specific logger with a fancy prefix for each log
 * @export
 * @param {any} args arguments to be logged
 */
export function log(...args) {
    console.debug('%cANALYTICS', 'color: #7399C6', ':', ...args);
}
//# sourceMappingURL=logger.js.map